export const black = '#4D515E';

export const trueBlack = '#232734';

export const white = '#FFFFFF';

export const blue = '#007AFF';

export const lighterGrey = '#F9F9F9';

export const lightGreen = '#E6FBEE';

export const green = '#02BF8E';

export const greenDark = '#36B18A';

export const lightGrey = '#F0F1F2';

export const grey = '#D4D5D8';

export const darkGrey = '#858A97';

export const amber = '#D2C86E';

export const lightRed = '#FFEEEE';

export const red = '#FF6C6C';

export const lightblue = '#42aaff';

const colors = {
  black,
  trueBlack,
  white,
  blue,
  green,
  greenDark,
  lightGreen,
  lightGrey,
  grey,
  darkGrey,
  lighterGrey,
  amber,
  red,
  lightRed,
  lightblue,
};

export default colors;
